import type { AppRouteModule } from '@/router/types';
import { t } from '@/hooks/web/useI18n';

const aiModuleRoute: Array<AppRouteModule> = [
  {
    path: '/xmAi/xmAgentMg',
    name: 'xmAgentMg',
    meta: {
      title: t('AI模块'),
    },
    component: () =>
      import(
        /* webpackChunkName: "ngsUserMainPage" */ '@/views/aiModule/aiAgentMg/index.vue'
        ),
  },

  {
    path: '/xmAi/xmAgentMg/intelligentQuotation',
    name: 'intelligentQuotation',
    component: () =>
      import(/* webpackChunkName: "ngsUserMainPage" */ '@/views/aiModule/detail/intelligentQuotation/index.vue'),
    meta: {
      title: t('智能报价'),
    }
  }
];

export default aiModuleRoute;
